/* @flow */
import { PICK_BRIDGE_RECOMMENDATION } from '../actions/up_next';
import type { UpNextState } from '../actions/up_next';
import type { Action } from '../actions/types';

export default function upNextState(state: UpNextState = {}, action: Action): UpNextState {
  switch (action.type) {
    case PICK_BRIDGE_RECOMMENDATION:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
